@if (entity()) {
  <div class="container">
    <!-- files section -->
    <app-files [files]="files()" [fileTypes]="fileTypes()" [disabled]="disabled()" />
    <!-- studies -->
    <app-studies [studies]="(studies$ | async)!" [(study)]="selectedStudy" [disabled]="disabled()" />
    <!-- custom tags -->
    @if (selectedStudy()?.customTags) {
      <app-upload-tags [data]="entity()!.tags" [disabled]="disabled()" />
    }
    <!-- buttons -->
    <div class="row">
      <div class="col-lg-9"></div>
      <div class="col-lg-3">
        <button type="button" class="btn btn-dark w-100" (click)="upload()" [attr.disabled]="disabled() ? true: null">
          <i class="bi bi-cloud-arrow-up"></i> Upload
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="container">
    @if (loading()) {
      <div class="text-center">
        <output class="spinner-border spinner-border-lg">
          <span class="visually-hidden">Loading...</span>
        </output>
      </div>
    } @else {
      <div class="text-center fs-3">
        Something went wrong. Please try again later.
      </div>
    }
  </div>
}
